// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn_content[data-v-19a8cb84]:focus,button[data-v-19a8cb84]:focus{outline:none}.lol[data-v-19a8cb84]{color:#fff!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
